import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext } from 'react';
import { getApolloContext } from '@apollo/client';
import { useStore } from 'jotai';
import userAtom from 'global-state/user/userAtom';
import logoutClientSession from './logoutClientSession';
import useResetUserData from './useResetUserData';
const useLogoutClient = () => {
  const $ = _c(5);
  const resetUserData = useResetUserData();
  const store = useStore();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getApolloContext();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    client: contextClient
  } = useContext(t0);
  let t1;
  if ($[1] !== contextClient || $[2] !== resetUserData || $[3] !== store) {
    t1 = t2 => {
      const {
        client: t3,
        reloadsPage: t4
      } = t2 === undefined ? {} : t2;
      const client = t3 === undefined ? contextClient : t3;
      const reloadsPage = t4 === undefined ? false : t4;
      logoutClientSession({
        client,
        hadUser: !!store.get(userAtom),
        reloadsPage,
        resetUserData
      });
    };
    $[1] = contextClient;
    $[2] = resetUserData;
    $[3] = store;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const logoutClient = t1;
  return logoutClient;
};
export default useLogoutClient;